import React, { useState } from 'react'
import View from './new/View'
import { connect } from 'react-redux'
import { authorization } from './../../../../Module/Auth/Auth'
import {
  INVENTORY_MOVEMENT_IN,
  INVENTORY_MOVEMENT_OUT,
} from './../../../../shared/constants'
import { processInventoryMovements } from './../../../../Module/graphQL/index'
import { urlGet } from './../../../../Utils/URL'

const Controller = props => {
  var [selectedTags, setSelectedTags] = useState(getInitialSelectedTags())

  /**
   * Assign inventory to a user
   * @param {object} inventoryObj Details about the inventory item.
   * @param {number} quantity The quantity
   * @param {string} ambassadorId The ambassador id
   * @returns {Promise}
   */
  const assignInventoryToUser = async function(
    inventoryObj,
    quantity,
    ambassadorId,
  ) {
    var movements = [
      // If it's assigned to someone already then first return it
      inventoryObj.ambassadorId
        ? {
            cityId: parseInt(props.cityId, 10),
            quantity: quantity,
            inventoryId: parseInt(inventoryObj.inventoryId, 10),
            ambassadorId: parseInt(inventoryObj.ambassadorId, 10),
            comments: 'Returning inventory from user on the pickup page.',
            movement: INVENTORY_MOVEMENT_IN,
            dateTime: new Date().toISOString(),
          }
        : undefined,
      {
        cityId: parseInt(props.cityId, 10),
        quantity: quantity,
        inventoryId: parseInt(inventoryObj.inventoryId, 10),
        ambassadorId: parseInt(ambassadorId, 10),
        comments: 'Assigning to user on the pickup page.',
        movement: INVENTORY_MOVEMENT_OUT,
        dateTime: new Date().toISOString(),
      },
    ].filter(o => o)
    var response = await processInventoryMovements(
      authorization.getAPIKey(),
      movements,
    )
    var result = await response.json()
    if (result.errors && result.errors[0]) alert(result.errors[0].message)
  }

  /**
   * Assign inventory from a user
   * @param {object} inventoryObj Details about the inventory item.
   * @param {number} quantity The quantity
   * @param {string} ambassadorId The ambassador id
   * @returns {Promise}
   */
  const returnInventoryFromUser = async function(
    inventoryObj,
    quantity,
    ambassadorId,
  ) {
    var response = await processInventoryMovements(authorization.getAPIKey(), [
      {
        cityId: parseInt(props.cityId, 10),
        quantity: quantity,
        inventoryId: parseInt(inventoryObj.inventoryId, 10),
        ambassadorId: parseInt(ambassadorId, 10),
        comments: 'Returning inventory from user on the pickup page.',
        movement: INVENTORY_MOVEMENT_IN,
        dateTime: new Date().toISOString(),
      },
    ])
    var result = await response.json()
    if (result.errors && result.errors[0]) alert(result.errors[0].message)
  }

  var { brandAmbassadors, cityDataLoaded, clients, campaigns } = props

  var isLoading = brandAmbassadors === undefined || cityDataLoaded !== true
  if (isLoading) return null

  var clientsHash = {}
  clients.forEach(c => (clientsHash[c.id] = c))
  var enabledClients = {}
  // Filter out all the non active city data
  campaigns = campaigns.filter(c => {
    if (c.status !== 'ACTIVE' || !clientsHash[c.client.id]) return false
    enabledClients[c.client.id] = clientsHash[c.client.id]
    return true
  })

  return (
    <View
      cityId={props.cityId}
      campaigns={campaigns}
      clients={Object.values(enabledClients)}
      brandAmbassadors={brandAmbassadors}
      assignInventoryToUser={assignInventoryToUser}
      returnInventoryFromUser={returnInventoryFromUser}
      selectedTags={selectedTags}
      onSelectedTagsChange={setSelectedTags}
    />
  )
}

const mapStateToProps = state => {
  return {
    authToken: authorization.getAPIKey(),
  }
}

export default connect(mapStateToProps)(Controller)

const getInitialSelectedTags = () => {
  let selectedTags = []
  const tags = urlGet('tag')
  const search = urlGet('search')
  // Many tags
  if (Array.isArray(tags)) {
    selectedTags = [...selectedTags, ...tags]
  }
  // One tag
  if (typeof tags === 'string') {
    selectedTags = [...selectedTags, tags]
  }
  // Search
  if (typeof search === 'string') {
    selectedTags = [...selectedTags, search]
  }
  return selectedTags
}



// WEBPACK FOOTER //
// ./src/Containers/Form/City/Pickup/index.js